/// <reference path="../types/index.d.ts" />

import '../client_forms/tcanewportwed/style.css';
import FormStructure from './tcanewportwed/form_structure';

export default FormStructure;